/**
 * wql
 * @description 作业记录管理
 * @Date  2020/10/31
 */
import React from "react";
import {connect} from "dva";
import {templateConfig, reduxTemplateCofig} from "./config";
import {handleExportHeader} from '@/utils/handleTabelHeaderUtils';

import {component_tool, framework_tool,utils_tool} from '../../../tool';
let {Session } = utils_tool;

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport} = component_tool;


class HomeworkRecordList extends WizContainer {
  componentName = 'homeworkRecordList';

  constructor(props) {
    super(props);

    this.state = {};
    this.record = {}


  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  checkHandler(nextProps, nextState, key){
    let o = nextProps[key]
    if (o['success']) {
      // wizNotice.success(o['msg'])
      let id = o.data;
      let url = location.origin + '/#/homeworkRecord/homeworkRecordAudit?id=' + id
      window.open(url, '_blank');
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _export(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      let column = [
        {
          headerName: "标题",
          field: "name",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "标题",
          field: "name",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "提交人姓名",
          field: "fullName",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "提交人账号",
          field: "userName",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "提交时间",
          field: "submitTime",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "组织名称",
          field: "orgName",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "组织编码",
          field: "orgCode",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: { vertical: 'bottom', horizontal: 'left' },
          },
        },
        {
          headerName: "岗位",
          field: "positionName",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "是否通过",
          field: "pass",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          }
        },
        {
          headerName: "提交类型",
          field: "orderType",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          }
        },
        {
          headerName: "标签",
          field: "labelIds",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "状态",
          field: "state",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "成绩",
          field: "score",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "评分人",
          field: "reviewerName",
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: "当前评分人",
          field: "currentReviewerName",
          width: 10,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        }
      ]
      let dataList = o.data
      dataList.forEach(e => {
        if (e.state == 0) {
          e.state = '未提交'
        } else if (e.state == 1) {
          e.state = '已提交'
        } else if (e.state == 2) {
          e.state = '已批阅'
        }
        if (e.pass === 0) {
          e.pass = '未通过'
        } else if(e.pass === 1){
          e.pass = '通过'
        }else{
          e.pass =""
        }
        if (e.order === 1) {
          e.orderType = '首次提交'
        } else if(e.order > 1){
          e.orderType = '重复提交'
        }else{
          e.orderType =""
        }
      })
      WizBrowserExport({
        title: '作业记录',
        sheetName: '作业记录',
        columns: column.filter((_, index) => index),
        rows: dataList,
        filename: '作业记录.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _componentWillMount() {
    const { history } = this.props
    if (history.location && history.location.pathname === '/homework/homeworkRecordList') {//直接进来
      return ;
    }
    let record = this.props.location.record;
    if (record) {
      // Session.set('homeworkInfoLook', {});
      this.record = record;
    }
    // if (Session.get('homeworkInfoLook')) {
    //   this.record = Session.get('homeworkInfoLook');
    // }
  }


  _render() {
    let entityId = this.record.name;
    let _reduxTemplateConfig = reduxTemplateCofig({
      templateConfig: templateConfig({entityId,_this: this}),
      apiDataFormat: {
        enable: this._handleCMD,
        export: this._export,
        getPathContent: this._getPathContent,
        updateState: this._handleCMD,
        del: this._handleCMD,
        check:this.checkHandler
      },
      entityId:entityId
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(HomeworkRecordList);
